import React from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle, Tag } from "lucide-react";
import { waLink } from "@/constants/site";

const CAMPAIGNS = [
  {
    title: "Lazer Epilasyon Paketleri",
    desc: "Tüm vücut ve bölgesel kombinasyonlarda avantajlı seans paketleri.",
    badge: "Popüler",
    id: "lazer-paket",
  },
  {
    title: "Bölgesel İncelme Paketleri",
    desc: "G5, EMS ve Lenf Drenaj kombinasyonlu özel şekillendirme programları.",
    badge: "Yeni",
    id: "incelme-paket",
  },
  {
    title: "Saten Yüz Germe Paketleri",
    desc: "Radyo frekans seansları için kombinli avantajlı uygulama paketleri.",
    badge: "Önerilen",
    id: "yuz-germe-paket",
  },
  {
    title: "Cilt Bakımı Protokolleri",
    desc: "3D cilt analizine göre Hydrafacial ve Kore bakımı kombinleri.",
    badge: "Sınırlı",
    id: "cilt-paket",
  },
];

export default function Campaigns() {
  return (
    <section
      id="kampanyalar"
      data-testid="campaigns-section"
      className="iona-section bg-[#F4F1F9]"
    >
      <div className="iona-container">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
              — Avantajlı Fırsatlar
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight">
              Size özel <span className="italic text-[#5E2A84]">kampanyalar</span>
            </h2>
          </div>
          <p className="text-[#4A4A4A] max-w-sm">
            Sezona özel paketlerimiz ve avantajlı protokoller ile premium
            bakımı uygun fiyatlarla deneyimleyin.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {CAMPAIGNS.map((c) => (
            <div
              key={c.id}
              data-testid={`campaign-card-${c.id}`}
              className="group relative bg-white rounded-3xl p-7 border border-white iona-hover-lift overflow-hidden flex flex-col"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#F4F1F9] rounded-full -translate-y-16 translate-x-16 group-hover:scale-150 transition-transform duration-700" />
              <div className="relative">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#5E2A84]/10 text-[#5E2A84] text-[10px] uppercase tracking-wider mb-6">
                  <Tag className="w-3 h-3" />
                  {c.badge}
                </div>
                <h3 className="font-serif text-xl text-[#1A1A1A] mb-3 leading-snug">
                  {c.title}
                </h3>
                <p className="text-sm text-[#4A4A4A] mb-8 leading-relaxed min-h-[60px]">
                  {c.desc}
                </p>
              </div>
              <a
                href={waLink(`Merhaba, ${c.title} kampanyası hakkında detaylı bilgi almak istiyorum.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`campaign-cta-${c.id}`}
                className="mt-auto relative"
              >
                <Button
                  variant="outline"
                  className="w-full rounded-full border-[#5E2A84]/20 text-[#5E2A84] hover:bg-[#5E2A84] hover:text-white hover:border-[#5E2A84] transition-all"
                >
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Detaylı Bilgi Al
                </Button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
